export const PAGO_BASE_OBJ = {
    forma_pago: "Efectivo",
    referencia: "",
    banco: "",
    terminal: "",
    monto: 0,
    fecha:null,
}


// WEBPACK FOOTER //
// ./src/constantes/casos/index.js